import React, { Fragment } from "react";
import { connect } from "react-redux";
import { updateContentFeed } from "signoxe/actions";

class Widget extends React.PureComponent {

  getTransition() {
    const profile = this.props.profile;
    if (
      profile &&
      profile.features &&
      profile.features.multiregion &&
      localStorage.getItem("multiregion_switch") == "true"
    ) {
      return this.props.feed.channel_details.transition_ratio;
    }

    return this.props.feed.transition;
  }



  render() {
    console.log("trannsi",this.getTransition())
    const props = this.props;
    const profile = props.profile;
    const condition = props.condition
    const multiRegionEnabled =
      profile &&
      profile.features &&
      profile.features.multiregion &&
      localStorage.getItem("multiregion_switch") == "true";


    return (
      <Fragment>
        {condition == true ?
          <select
            name="transition_select"
            id="transition_select"
            title="Select a transition"
            value={this.getTransition()}
            onChange={(e) => this.props.setTransition(e.target.value)}
          >
            <option value="NONE">None</option>
            <option value="FADEIN">Fade In</option>
          </select> :
          <select
            name="transition_select"
            id="transition_select"
            title="Select a transition"
            value={this.getTransition()}
            onChange={(e) => this.props.setTransition(e.target.value)}
          >
            <option value="NONE">None</option>
            <option value="SLIDE_LEFT">Slide from Left</option>
            <option value="SLIDE_RIGHT">Slide from Right</option>
            <option value="RANDOM">Random</option>
            <option value="FADEIN">Fade In</option>
          </select>

        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setTransition: (value) =>
      dispatch(updateContentFeed(ownProps.feed.id, { transition_ratio: value })),
  };
};

export const TransitionSelectWidget = connect(
  mapStateToProps,
  mapDispatchToProps
)(Widget);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/TransitionSelectWidget/index.js